import Swiper from "swiper"
import {SwiperOptions} from "swiper/types"
import {Keyboard, Pagination, Navigation} from "swiper/modules"

const reviewSliders = document.querySelectorAll<HTMLElement>(".g-review.--slider")

reviewSliders.forEach((slider) => {
  const swiperSettings: SwiperOptions = {
    modules: [Keyboard, Pagination, Navigation],
    slidesPerView: 1,
    spaceBetween: 16,
    keyboard: {
      enabled: true,
    },
    breakpoints: {
      1200: {
        slidesPerView: 3,
      },
      991: {
        slidesPerView: 2,
      },
    },
    navigation: {
      nextEl: slider.closest(".s-review__slider")?.querySelector<HTMLElement>(".g-review__button.--next"),
      prevEl: slider.closest(".s-review__slider")?.querySelector<HTMLElement>(".g-review__button.--prev"),
    },
    pagination: {
      el: slider.querySelector<HTMLElement>(".g-review__pagination"),
      clickable: true,
    },
    on: {
      init: () => {
        slider.classList.remove("--loading")
      },
    },
  }

  new Swiper(slider, swiperSettings)
})
